import { helper } from "lib/helper";
import { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import usersModel from "models/users.model";
import bookingModel from "models/booking.model";
import BookingBuddyInfo from "./BookingBuddyInfo";
import BookingUserInfo from "./BookingUserInfo";
import BookingExperinceInfo from "./BookingExperinceInfo";
import { formatDateTime } from "../../lib/helper";
const EditBookingPage = ({ edit }) => {
  const { id } = useParams(); // Getting booking ID from the route params
  const [booking, setBooking] = useState(null);
  const [booking_status, setBookingStatus] = useState(null);
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState({
    status: "",
  });
  const [activeTab, setActiveTab] = useState("booking");

  useEffect(() => {
    const getBookingData = async () => {
      const res = await usersModel.getBookingDetails(id);
      setBooking(res.data[0]);
      setBookingData(res.data[0]);
      setBookingStatus(res.data[0].status);
      // console.log(res)
    };
    getBookingData();
  }, [id]);

  // Function to handle form field change
  const handleChange = (e) => {
    setBooking({ ...booking, [e.target.name]: e.target.value });
    setBookingData({ ...booking, [e.target.name]: e.target.value });
  };

  // Function to handle booking save
  const handleSaveBooking = (e) => {
    e.preventDefault();
    if (id) {
      try {
        helper.sweetalert
          .confirm("Are you sure you want to save changes?", "info", true)
          .then((result) => {
            if (result.isConfirmed) {
              bookingModel.editBookingDetails(bookingData, id).then((res) => {
                if (res) {
                  helper.sweetalert.toast("Booking updated", "success");
                  navigate(-1);
                }
              });
              console.log("Booking changes saved", booking);
              // Actual save logic here
            }
          });
      } catch (error) {
        helper.sweetalert.toast(
          error.response?.data?.message || "Update failed",
          "warning"
        );
      }
    } else {
      helper.sweetalert.toast("Please fill all fields", "warning");
    }
  };

  if (!booking) {
    return <div>Loading...</div>;
  }
  console.log(booking);
  return (
    <>
      <Container className="pt-7" fluid>
        <Nav tabs className="mb-3">
          {["booking", "experience", "user", "buddy"].map((tab) => (
            <NavItem key={tab} className="shadow-lg bg-white ">
              <NavLink
                className={activeTab === tab ? "active " : ""}
                style={{
                  cursor: "pointer",
                  backgroundColor: activeTab === tab ? "#FFF9E1" : "",
                  color: activeTab === tab ? "black" : "",
                  boxShadow: "white",
                }}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {activeTab === "booking" && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">
                    {edit ? "Edit Booking" : "View Booking"}
                  </h3>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="username">First Name</Label>
                          <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            defaultValue={booking?.user?.firstName}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="username">Last Name</Label>
                          <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            defaultValue={booking?.user?.lastName}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="bookingId">Booking ID</Label>
                          <Input
                            type="text"
                            name="bookingId"
                            id="bookingId"
                            defaultValue={`GB001${booking?._id}`}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="experienceDateTime">
                            Experience Time duration
                          </Label>
                          <Input
                            type="text"
                            name="experienceDateTime"
                            id="experienceDateTime"
                            defaultValue={`${booking?.startTime + " - " + booking?.endTime}`}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="bookedOn">Booked On</Label>
                          <Input
                            type="text"
                            name="bookedOn"
                            id="bookedOn"
                            defaultValue={new Date(
                              booking?.bookingDate
                            ).toLocaleDateString("en-GB")}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="paymentMode">Payment Mode</Label>
                          <Input
                            type="text"
                            name="paymentMode"
                            id="paymentMode"
                            defaultValue={booking?.transaction?.mode}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="totalPayment">Total Payment</Label>
                          <Input
                            type="text"
                            name="price"
                            id="price"
                            className="cur"
                            defaultValue={booking?.price}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="status">Status</Label>
                          <Input
                            type="select"
                            name="status"
                            id="status"
                            defaultValue={booking?.status}
                            onChange={handleChange}
                            disabled={!edit}
                          >
                            <option value="completed">Completed</option>
                            <option value="pending">Pending</option>
                            <option value="cancelled">Cancelled</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="cancelled_by_type">Event Date</Label>
                          <Input
                            type="text"
                            name="event_date"
                            id="event_date"
                            defaultValue={formatDateTime(booking?.event_id?.date)}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      {booking_status === "cancelled" && (
                        <Col md="4">
                          <FormGroup>
                            <Label for="refund_status">Refund Status</Label>
                            <Input
                              type="select"
                              name="refund_status"
                              id="refund_status"
                              defaultValue={booking?.refund_status}
                              disabled={!edit}
                            >
                              <option value="">Not initiated</option>
                              <option value="completed">Completed</option>
                              <option value="pending">Pending</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      )}
                      {booking_status === "cancelled" && (
                        <Col md="4">
                          <FormGroup>
                            <Label for="cancelled_on">Cancelled On</Label>
                            <Input
                              type="text"
                              name="cancelled_on"
                              id="cancelled_on"
                              defaultValue={formatDateTime(booking?.cancelled_on)}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {booking_status === "cancelled" && (
                        <Col md="4">
                          <FormGroup>
                            <Label for="cancelled_by_type">Cancelled By</Label>
                            <Input
                              type="text"
                              name="cancelled_by_type"
                              id="cancelled_by_type"
                              defaultValue={booking?.cancelled_by_type}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {booking_status === "cancelled" && (
                        <Col md="4">
                          <FormGroup>
                            <Label for="cancelled_by">Cancelled User</Label>
                            <Input
                              type="text"
                              name="cancelled_by"
                              id="cancelled_by"
                              defaultValue={booking?.cancelled_by?.firstName + " " + booking?.cancelled_by?.lastName}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {booking_status === "cancelled" && (
                        <Col md="4">
                          <FormGroup>
                            <Label for="cancelled_before">Cancelled Before Hours</Label>
                            <Input
                              type="text"
                              name="cancelled_before"
                              id="cancelled_before"
                              defaultValue={booking?.cancelled_before}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label for="experienceDetails">
                            Experience Details
                          </Label>
                          <Input
                            type="textarea"
                            name="description"
                            id="description"
                            defaultValue={booking?.experience?.description}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row></Row>
                    <Button color="primary" onClick={() => navigate(-1)}>
                      Back
                    </Button>
                    {edit && (
                      <Button color="success" onClick={handleSaveBooking}>
                        Save Booking
                      </Button>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </div>
          </Row>
        )}

        {activeTab === "buddy" && <BookingBuddyInfo data={booking?.buddy} />}

        {activeTab === "experience" && (
          <BookingExperinceInfo experience={booking?.experience} />
        )}

        {activeTab === "user" && <BookingUserInfo data={booking?.user} />}
      </Container>
    </>
  );
};

export default EditBookingPage;
